import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class Login {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * Login constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Log in by getting the access token.
     *
     * @param {String} email
     * @param {String} password
     *
     * @returns {Promise}
     */
    handle(email, password) {
        return this.apiService.post(ApiEndpoints['auth.login'], {
            email: email,
            password: password,
        });
    }
}
